<template>
  <div :class="['relative', 'bg-black/40']">
    <!-- 固定定位背景 -->
    <div :class="['absolute inset-0 z-[-2]', 'bg-[url(/img/bg/home-1.avif)] bg_img bg-fixed']" />
    <!-- 主内容容器 -->
    <div
      :class="[
        'page_view overflow-hidden',
        'flex flex-col items-center justify-center',
        'lg:py-32 py-16',
      ]"
    >
      <CommonBanner
        :title="t('page.index.certification.fragment.title')"
        :desc="t('page.index.certification.fragment.desc')"
        class="lg:mb-20 mb-10"
        theme="dark"
      />
      <!-- 卡片组容器 -->
      <div :class="['grid lg:gap-10 gap-8']">
        <!-- 资质认证单卡片 -->
        <Motion
          v-for="(item, index) in certificationImgs"
          :key="item.title"
          :initial="{ x: index % 2 === 0 ? 100 : -100, opacity: 0 }"
          :while-in-view="{ x: 0, opacity: 1 }"
          :in-view-options="{
            once: true,
            amount: 0.5,
          }"
          :transition="{
            type: 'spring',
            stiffness: 100,
            damping: 20,
            delay: 0,
          }"
        >
          <!-- 悬浮流光特效容器 -->
          <VueBitsGlareHover
            glare-color="#ffffff"
            :glare-opacity="0.3"
            :glare-size="300"
            :transition-duration="800"
            :play-once="false"
            className="hover:scale-102 active:scale-98 transition-all"
          >
            <!-- 卡片本体 -->
            <div
              :class="[
                'grid lg:grid-cols-[1fr_28rem]',
                'bg-secondary',
                'text-white group/certification',
                'hover:shadow-xl',
                'lg:border-l-12 border-l-0 lg:border-t-0 border-t-6 border-black/20',
              ]"
            >
              <!-- 左側文字容器 -->
              <div
                :class="[
                  'flex flex-col lg:items-start items-center justify-start gap-4',
                  'lg:p-10 p-4 lg:pr-0',
                  'lg:text-start text-center',
                  'hover:cursor-default',
                ]"
              >
                <!-- 图标和标题容器 -->
                <div
                  :class="[
                    'relative',
                    'flex items-center justify-center lg:gap-4 gap-2 lg:flex-row flex-col',
                  ]"
                >
                  <UIcon name="emojione:trophy" class="lg:size-10 size-8 shrink-0" />
                  <h3
                    class="lg:text-3xl text-xl font-bold group-hover/certification:text-primary transition-colors duration-500"
                  >
                    {{ t(item.title) }}
                  </h3>
                </div>
                <!-- 卡片正文 -->
                <p class="lg:text-lg text-md">{{ t(item.desc) }}</p>
              </div>

              <!-- 右侧资质图片容器 -->
              <div
                :class="[
                  'grid grid-flow-col items-center justify-center gap-2 lg:p-6 p-4 bg-primary',
                  'lg:bg-linear-to-l lg:from-primary lg:to-secondary bg-linear-to-t from-primary to-secondary',
                ]"
              >
                <!-- 资质证书图片-->
                <NuxtImg
                  v-for="(imgItem, index) in item.imgUrl"
                  :key="`certification-${index}`"
                  :src="imgItem"
                  draggable="false"
                  class="object-contain bg-default image-zoomable lg:max-h-42 max-h-36"
                  alt="Certification"
                />
              </div>
            </div>
          </VueBitsGlareHover>
        </Motion>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  /** 证书图片 */
  const certificationImgs = [
    {
      title: t('page.index.certification.tapa.title'),
      desc: t('page.index.certification.tapa.desc'),
      imgUrl: [
        '/img/certification/tapa-shenzhen.webp',
        '/img/certification/tapa-thailand.webp',
        '/img/certification/tapa-vietnam.webp',
      ],
    },
    {
      title: t('page.index.certification.customs_china.title'),
      desc: t('page.index.certification.customs_china.desc'),
      imgUrl: [
        '/img/certification/customs-china-1.webp',
        '/img/certification/customs-china-2.webp',
      ],
    },
    {
      title: t('page.index.certification.license_road_china.title'),
      desc: t('page.index.certification.license_road_china.desc'),
      imgUrl: ['/img/certification/license-road-china.webp'],
    },
    {
      title: t('page.index.certification.itl_vietnam.title'),
      desc: t('page.index.certification.itl_vietnam.desc'),
      imgUrl: ['/img/certification/itl-vietnam.webp'],
    },
    {
      title: t('page.index.certification.itl_thailand.title'),
      desc: t('page.index.certification.itl_thailand.desc'),
      imgUrl: ['/img/certification/itl-thailand.webp'],
    },
  ]
</script>
